/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type CohortFilterGroupOp = (typeof CohortFilterGroupOp)[keyof typeof CohortFilterGroupOp];

export const CohortFilterGroupOp = {
  and: 'and',
  or: 'or',
} as const;
